import { LoadBreakout } from "./LoadBreakout";

export class LoadBreakoutParameters {
    dispatchBeginDate: string = '';
    dispatchEndDate: string = '';
    loads: number = 0;
    deliveryTime: string = '';
    loadBreakoutList: LoadBreakout[] = [];
}